import axios from './index'

export default {
  list(params) {
    return axios.get('/api/v1/placereservation/place/detail', { params })
  },
  listMovements(params) {
    return axios.get('/api/v1/placereservation/table/movements-table', { params })
  },
}